import React from "react";

import { Badge, Dropdown, Image } from "react-bootstrap";
import { Table } from "react-bootstrap";

// import CardDropdown from "../../components/CardDropdown";

const TableRow = ({
  data,
  sr,
  viewEntry,
  updateEntry,
  deleteEntry,
  propLength,
}) => {
  return (
    <tr className="align-middle">
      <td className="text-center">{data.order}</td>
      <td className="text-center">
        <Image src={data.imageUrl} width="80" />
      </td>
      <td className="text-center">
        {data.status && <Badge bg="success">Active</Badge>}
        {!data.status && <Badge bg="warning">Inactive</Badge>}
      </td>

      <td className="text-center" style={{ minWidth: "180px" }}>
        <span style={{ cursor: "pointer" }} onClick={() => viewEntry(data)}>
          <i className={"bi bi-eye text-info me-2"}></i>
        </span>
        <span style={{ cursor: "pointer" }} onClick={() => updateEntry(data)}>
          <i className={"bi bi-pen text-warning me-2"}></i>
        </span>
        <span style={{ cursor: "pointer" }} onClick={() => deleteEntry(data)}>
          <i className={"bi bi-trash text-danger"}></i>
        </span>
        {/* <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              className="text-primary"
              onClick={() => updateEntry(data)}
            >
              Edit
            </Dropdown.Item>
          </div>
        </CardDropdown> */}
      </td>
    </tr>
  );
};

const BannersTable = ({ list = [], viewEntry, updateEntry, deleteEntry }) => {
  let i = 1;
  return (
    <Table responsive hover bordered style={{ fontSize: "14px" }}>
      <thead>
        <tr>
          <th scope="col" className="text-center">
            Order
          </th>
          <th scope="col" className="text-center">
            Banner
          </th>
          <th scope="col" className="text-center">
            Status
          </th>

          <th scope="col" className="text-center">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {list?.map((entry, index) => (
          <TableRow
            data={entry}
            key={index}
            sr={i++}
            propLength={list?.length}
            viewEntry={viewEntry}
            updateEntry={updateEntry}
            deleteEntry={deleteEntry}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default BannersTable;
